module.exports = __webpack_public_path__ + "static/img/uk-flag.a3fc321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/uk-flag.png
// module id = 206
// module chunks = 0